import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { NativeService } from 'src/service';
import { DatePipe } from '@angular/common';
declare var app;

@Component({
  selector: 'app-return-goods-detail',
  templateUrl: './return-goods-detail.component.html',
  styleUrls: ['./return-goods-detail.component.scss']
})
export class ReturnGoodsDetailComponent extends GridBaseCase implements AfterViewInit {
  // app-a2-product-inventory
    CustomInterfaceOptions: any = {
      header: '产品列表',
      // subHeader: 'Select your toppings',
      // message: '$1.00 per topping',
      // translucent: true
    };
    month: any = new Date();
    segmentVal: any = 0;
    typeout: any = null;
    searchDate = null;
    searcholdDate=null;
    isSelectCahage:boolean = false;//是否多次点击
    dataArrayList: Array<any> = [];
    productArrayList:Array<any> = [];
    @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
    RecordCount: Number = 0;//列表总数量
    addobject: any = {};//多选
    pageName:string = null;
    isAddProduct:boolean = true;//是否可以添加产品
    isSubmitData:boolean = true;//是否可以提交数据
    isAndroid4:boolean = false;//安卓4以下
    max:any;//最大日期
    isreturnGoods:boolean  =false;//是否退货页面
    constructor(
      private platform: Platform,
      private http: HttpCustomerService,
      private activaRouter: ActivatedRoute,
      private router: Router,
      private msg: MessageclientService,
      private com: CommonService,
      private native:NativeService,
      public baseService: BaseCase,
      public base:BaseModal
    ) { super();
      this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
      if(this.pageName=="ReturnGoods"){//消费者退货
        this.isreturnGoods=true;
      }
      // this.baseService.FixedSubmitBtn.configName = "ProductInventory";
      // this.baseService.FixedSubmitBtn.isShow = true;
      // this.baseService.FixedSubmitBtn.text = "全部提交";
      // this.baseService.FixedSubmitBtn.type = 1;
  
      this.isAndroid4 = this.com.Isandroidversion;
      this.max=this.com.TenTime;
    }
    EventLink(event,item){
      // console.log(item);
      localStorage.setItem("information",JSON.stringify(item));
      this.com.setHistoryUrl();
      // this.router.navigate([event.url+item.id.value]);
      this.com.Go(event.url+item.id.value);
    }
    
    ngAfterViewInit()
    {
      
    }
  
   
    loadMoreData(event) {
      let that = this;
      if (that.RecordCount == that.dataArrayList.length) {
        if( that.infiniteScroll){
          that.infiniteScroll.disabled = true;
        }
       
      } else {
        that.PageNumber++;
        this.LoadData(that.PageNumber);
      }
    }
    LoadData(PageNumber){
      let that = this;
    
      // console.log("1008611");
      that.PageNumber = PageNumber;
      if (PageNumber == 1) {
        that.loading = false;
        that.apiObj['status'] = false;
        that.apiObj['msg'] = '';
      }
      // console.log(that.element);
      const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
      let body = new WebParameterContext();
      body.Account = that.com.GetAccount;
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      }else{
        that.msg.Alert("服务端数据配置有误,请联系管理员");
        return;
      }
      // body.ConfigName="MemberManage";
      body.OpType = "query";
      body.ConfigType = "view";
      body.RowsPerPage = app.RowsPerPage;
      body.PageNumber = PageNumber;
      body.Client.PageName = PageName;
      body.Client.ApiType = "Element";
      body.Client.Name = that.element.name;
      body.Client.ClientType = 2;
      if (that.platform.is("android")) {
        body.Client.ClientType = 0;
      } else if (that.platform.is("ios")) {
        body.Client.ClientType = 1;
      }
      let typeObj = {};
      // if(PageName == 'RepurchaseReminder'){
      //   typeObj = {"Type":1};
      // }else if(PageName == 'TransitionReminder'){
      //   typeObj = {"Type":2};
      // }else if(PageName == 'AwakenReminder'){
      //   typeObj = {"Type":3};
      // }else if(PageName == 'BirthdayReminder'){
      //   typeObj = {"Type":4};
      // }else if(PageName == 'NewcustomersReminder'){
      //   typeObj = {"Type":5};
      // }
      // body.RequestBody = JSON.stringify(typeObj);
      that.http.post(app.DEFAULTURL, body).then(data => {
       
        /****判断是否第一页begin****/
        if(PageNumber == 1){
          that.dataArrayList = [];
          that.apiObj['status'] = data.ResponseMessage.Success;
          that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
          that.loading = true;
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.complete();
          }
         
        }
        /****判断是否第一页end****/
        if (data.ResponseMessage.Success) {
          data.Status.Datas.forEach(function (item) {
            let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
              }
            });
            that.dataArrayList.push(objfield);
            
            that.dataArrayList.forEach(data=>{
              if(data.orderCreateDate.value){
                let datepie: DatePipe = new DatePipe("en-US");
                data.orderCreateDate.value =  datepie.transform(data.orderCreateDate.value.replace(/-/g,"/"), 'yyyy-MM-dd');
              }
            });
            //console.log(that.dataArrayList);
          });
          // console.log(that.dataArrayList,"dataArrayList");
          /****上拉加载数据begin****/
          that.RecordCount = data.Status.RecordCount;
          if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
            // that.infiniteScroll.disabled = true;
            if( that.infiniteScroll){
              that.infiniteScroll.disabled = true;
            }
          }else{
            if( that.infiniteScroll){
              that.infiniteScroll.disabled = false;
            }
          }
          /****上拉加载数据end****/
        }
  
      }).catch(error => {
        that.apiObj['status'] = false;
        that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
        that.loading = true;
        // console.log(error);
      });
   }
    
    Eventdatetime(event,item){
      item.orderCreateDate.value=event.detail.value;
      // console.log(item);
      // console.log(event);
    }
   
  }